import axios from 'axios';

export const login = (mobileNumber, password) =>
  axios.post('auth/login', {
    mobileNumber,
    password,
  });

export const passwordRecoveryOtp = (mobileNumber, captcha, key) =>
  axios.post('auth/password-recovery/verification-code', {
    mobileNumber,
    captcha,
    key,
  });

export const reset = (mobileNumber, password, otp) =>
  axios.post('auth/reset', {
    mobileNumber,
    password,
    otp,
  });

export const getCaptcha = () => axios.get('captcha/generate');
